import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Form} from "react-bootstrap";
import {vitals} from "../utils";
import {update} from "immutable";

export const VitalsConfigureView = forwardRef((props: { vitals: any[], updateVitals: any }, ref) => {

    const handleChange = (e) => {
        if (e.target.checked) {
            if(props.vitals) {
                props.updateVitals([...props.vitals, e.target.id])
            } else {
                props.updateVitals([e.target.id])
            }
        } else {
            props.updateVitals(props.vitals.filter(v => v != e.target.id))
        }
    };


    return (
        <div className="fs-7 text-info">
            {vitals.map(v =>  {
                return <div className="form-check d-inline-block" key={v.name}>
                    <input className="form-check-input" type="checkbox" value="" onChange={handleChange} id={v.id} checked={props.vitals && props.vitals.filter(pv => pv == v.id).length > 0}/>
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                        {v.name}&nbsp;&nbsp;&nbsp;&nbsp;
                    </label>
                </div>
            })}
        </div>
    );
});

VitalsConfigureView.displayName = "VitalsConfigureView";